import currency from './currency'
import pluralize from './pluralize'

export {
  currency,
  pluralize
}


// WEBPACK FOOTER //
// core-build-local/filters/other/index.js